export default function ServiceOverview() {
  const services = [
    {
      title: 'Platform Development',
      subtitle: 'Native iOS engineering',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20close-up%20of%20brushed%20titanium%20surface%20with%20subtle%20gradient%20lighting%2C%20warm%20metallic%20tones%2C%20minimalist%20material%20texture%2C%20no%20people%2C%20no%20electronics%2C%20pure%20material%20study%2C%20soft%20diffused%20illumination%2C%20industrial%20design%20aesthetic&width=800&height=800&seq=service-card-01-technopankai&orientation=squarish',
      icon: 'ri-smartphone-line',
    },
    {
      title: 'System Architecture',
      subtitle: 'Scalable foundations',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20glass%20layers%20overlapping%20with%20precise%20angular%20edges%2C%20warm%20cream%20and%20dark%20charcoal%20contrast%2C%20clean%20architectural%20composition%2C%20no%20people%2C%20no%20text%2C%20minimalist%20studio%20photography%2C%20soft%20lighting%20on%20transparent%20surfaces&width=800&height=800&seq=service-card-02-technopankai&orientation=squarish',
      icon: 'ri-layout-6-line',
    },
    {
      title: 'Performance Engineering',
      subtitle: 'Speed &amp; reliability',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20macro%20photography%20of%20polished%20ceramic%20surface%20with%20fine%20linear%20patterns%2C%20warm%20off-white%20and%20dark%20gray%20tones%2C%20smooth%20matte%20texture%2C%20no%20people%2C%20minimalist%20aesthetic%2C%20precision%20engineering%20visual%2C%20soft%20studio%20lighting&width=800&height=800&seq=service-card-03-technopankai&orientation=squarish',
      icon: 'ri-speed-up-line',
    },
  ];

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <span className="font-label text-xs tracking-widest uppercase text-secondary-600 bg-secondary-100/80 px-3 py-1.5 rounded-full">What We Do</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-5">Core capabilities</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div key={service.title} className="group relative overflow-hidden rounded-2xl aspect-[4/5]">
              <img
                src={service.image}
                alt={service.subtitle}
                title={`${service.title} — ${service.subtitle}`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 mb-4">
                  <i className={`${service.icon} text-accent-400 text-xl`}></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-1">
                  {service.title}
                </h3>
                <p className="font-body text-sm text-background-200/80">{service.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}